import React, { HTMLAttributes } from 'react';

import {
  Container,
  Button,
  WysiwygField,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';
import { DynamicMediaItem } from '@uncinc/react-drupal-core';

import {
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';
import { BlockCTA } from '../../../types/uncinc_profile/blocks';
import {
  SCREEN_NORMAL, SCREEN_WIDE,
} from '../../../config/constants';

import './style.scss';

const BODY_MAX_LENGTH = 135;

interface ParagraphCTAProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<BlockCTA>;
}

const ParagraphCTA: React.FC<ParagraphCTAProps> = ({
  entity,
}) => {
  const paragraphCTA = entity.toJS();

  const title = paragraphCTA.info?.[0]?.value;
  const body = paragraphCTA.body?.[0]?.processed.substring(0, BODY_MAX_LENGTH);
  const linkTitle = paragraphCTA.field_link?.[0]?.title;
  const linkUri = paragraphCTA.field_link?.[0]?.alias || paragraphCTA.field_link?.[0]?.uri;
  const linkTitleSecondary = paragraphCTA.field_link_secondary?.[0]?.title;
  const linkSecondary = paragraphCTA.field_link_secondary?.[0];
  const linkUriSecondary = linkSecondary?.alias || linkSecondary?.uri;
  const media = paragraphCTA.field_media[0];


  const { width } = useWindowDimensions();
  const isMobile = width <= SCREEN_NORMAL;
  const isWide = width >= SCREEN_WIDE;

  const imageRatio = () => {
    if (isMobile && body) {
      return '4_3';
    }
    if (isWide) {
      return '1_1';
    }
    return '3_4';
  };

  return (
    <div className="Paragraph ParagraphCTA">
      <Container>
        <div className="ParagraphCTA__wrapper">
          <div className="triangle triangle--cut" />

          {media && (
            <DynamicMediaItem
              className="ParagraphCTA__image"
              media={media}
              imageAspectRatio={imageRatio()}
            />
          )}

          <div className="ParagraphCTA__wrapper__content">
            <div className="ParagraphCTA__wrapper__content__text">
              {title && (
                <div className="ParagraphCTA__title">{title}</div>
              )}

              {body && (
                <WysiwygField html={body} />
              )}
            </div>

            <div className="ParagraphCTA__wrapper__content__buttons">
              {linkUri && (
                <Button
                  href={linkUri}
                  className="ParagraphCTA__button Button--CTA icon-after icon-arrow-right icon-variant-1"
                >
                  {linkTitle}
                </Button>
              )}

              {linkUriSecondary && (
                <Button
                  href={linkUriSecondary}
                  primary={false}
                  className="ParagraphCTA__secondary-button Button--textual icon-after icon-arrow-right"
                >
                  <span>{linkTitleSecondary}</span>
                </Button>
              )}
            </div>

          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphCTA;
